export default "__VITE_ASSET__DyQwxPXu__"